import React from 'react';

import { FormField } from '~/eds/src/components/FormField/FormField';
import { TextArea } from '~/eds/src/components/TextArea/TextArea';
import {
  FormField as FormFieldType,
  ShortResponseField as ShortResponseFieldType,
} from '~/types/SSOForm';

type Props = {
  formField: FormFieldType<ShortResponseFieldType>;
  errors?: string[];
  onChange: (value: string) => void;
  onExplain?: (value: string) => void;
};

export const LongResponseField = ({
  formField,
  errors = [],
  onExplain,
  onChange,
}: Props) => {
  return (
    <FormField
      label={formField.title}
      onExplain={onExplain ? () => onExplain(formField.fieldName) : undefined}
      input={TextArea}
      disabled={formField.disabled}
      readOnly={formField.disabled}
      value={formField.field.value}
      description={formField.description}
      enableCopy={formField.copiable}
      optional={!formField.required}
      error={
        errors.length > 0
          ? (formField.patternError ?? errors.join(', '))
          : undefined
      }
      onChange={onChange}
      name={formField.fieldName}
    />
  );
};
